//export const API_URL = "https://spedire.blockmob.io"
//export const API_URL = "http://localhost:4000"

export const API_URL = "https://marketingpostale-be.vercel.app"

